<div class="row">
	<div class="spinner-container">
		<span class="spinner-border text-info"></span>
	</div>
</div>
